import React from 'react';
import { Bubble } from 'tea-component';
import type { IHighPriorityEventItem } from '../../types';
import './index.scss';

export interface IEventBubbleProps {
  /**
   * Bubble 浮层内容
   * 支持两种模式：
   * - ReactNode：静态内容，所有 Bubble 共享
   * - (event: IHighPriorityEventItem) => ReactNode：渲染函数，每个 Bubble 根据自身 event 生成独立内容
   */
  bubbleContent?:
    | React.ReactNode
    | ((event: IHighPriorityEventItem) => React.ReactNode);

  /**
   * Bubble 可见性变化回调
   * @param visible - 是否可见
   * @param event - 当前事件数据
   */
  onBubbleVisibleChange?: (
    visible: boolean,
    event: IHighPriorityEventItem,
  ) => void;

  /** 当前事件数据 */
  event: IHighPriorityEventItem;

  /** Bubble 包裹的子元素 */
  children: React.ReactNode;
}

export default function EventBubble({
  bubbleContent,
  onBubbleVisibleChange,
  event,
  children,
}: IEventBubbleProps) {
  return (
    <Bubble
      overlayClassName="dbo-event-bubble-common-nobg"
      content={
        typeof bubbleContent === 'function'
          ? bubbleContent(event)
          : bubbleContent
      }
      dark={false}
      placement="left"
      onVisibleChange={(visible) => {
        onBubbleVisibleChange?.(visible, event);
      }}
    >
      {children}
    </Bubble>
  );
}
